import { styled, useTheme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { hideMessage } from '../../../store/Application.store';
import LoadingScreen from '../../components/LoadingScreen';
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';

const APP_BAR_MOBILE = 50;
const APP_BAR_DESKTOP = 60;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  backgroundColor: theme.palette.background.contrast,
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

const DarkBackground = styled('div')(({ theme }) => ({
  display: 'block',
  position: 'fixed',
  zIndex: 999,
  left: '0',
  top: '0',
  width: '100%',
  height: '100%',
  overflow: 'auto',
  color: `${theme.palette.primary.darker}AA`,
  backgroundColor: `${theme.palette.background.default}AA`
}));

export default function DashboardLayout({ children, sidebarConfig, roles }: any) {
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const state = useSelector((root: any) => root.application);

  const { enqueueSnackbar } = useSnackbar();

  if (state.message !== '') {
    dispatch(hideMessage());
    enqueueSnackbar(state.message, { variant: state.messageSeverity });
  }

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} children={children} />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
        sidebarConfig={sidebarConfig}
        roles={roles}
      />
      <MainStyle
        sx={{
          transition: theme.transitions.create('margin', {
            duration: theme.transitions.duration.complex
          }),
          ...(collapseClick && {
            ml: '102px'
          })
        }}
      >
        {state.isUiBlocked && (
          <DarkBackground>
            <LoadingScreen sx={{ opacity: '0.8' }} />
          </DarkBackground>
        )}
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
